import { Injectable } from '@angular/core';
import { RestApi } from '@core/api/rest.api';
import { RisikoOpkraevning } from '../risiko-opkraevning.model';

@Injectable({
  providedIn: 'root',
})
export class RisikoOpkraevningApi extends RestApi<RisikoOpkraevning> {
  endpoint = '/api/admin/risikoopkraevninger';
}
